var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretRight"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3538 8.85403L6.35378 13.854C6.30733 13.9005 6.25218 13.9373 6.19148 13.9625C6.13079 13.9876 6.06573 14.0006 6.00003 14.0006C5.93434 14.0006 5.86928 13.9876 5.80859 13.9625C5.74789 13.9373 5.69274 13.9005 5.64628 13.854C5.59983 13.8076 5.56298 13.7524 5.53784 13.6917C5.5127 13.631 5.49976 13.566 5.49976 13.5003C5.49976 13.4346 5.5127 13.3695 5.53784 13.3088C5.56298 13.2481 5.59983 13.193 5.64628 13.1465L10.2932 8.50028L5.64628 3.85403C5.55246 3.76021 5.49976 3.63296 5.49976 3.50028C5.49976 3.3676 5.55246 3.24035 5.64628 3.14653C5.7401 3.05271 5.86735 3 6.00003 3C6.13272 3 6.25996 3.05271 6.35378 3.14653L11.3538 8.14653C11.4003 8.19296 11.4372 8.24811 11.4623 8.30881C11.4875 8.36951 11.5004 8.43457 11.5004 8.50028C11.5004 8.56599 11.4875 8.63105 11.4623 8.69175C11.4372 8.75245 11.4003 8.80759 11.3538 8.85403Z",
    fill: "#D0D5DD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.6fe4f45c2756d2042f6c5157603a8b56.svg";
export { ForwardRef as ReactComponent };